import { captureException } from '@sentry/react'

export function logError(err: Error | string, logToSentry?: boolean): void {
  if (console) {
    // eslint-disable-next-line no-console
    console.error(err)
  }

  if (logToSentry) {
    captureException(err)
  }
}
